import { Route, Switch, Redirect } from 'react-router-dom';
import { createBrowserHistory as History } from 'history';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
//@ts-expect-error missing type definition
import { RECAPTCHA_KEY } from 'config';

import Layout, {
    LayoutVariants,
} from 'components/layout/UnauthorisedLayout/UnauthorisedLayout';
import LoginPage from 'components/pages/LoginPage/LoginPage';
import BexioAuthPage from 'components/pages/BexioAuthPage/BexioAuthPage';
import ResetPasswordPage from 'components/pages/ResetPasswordPage/ResetPasswordPage';
import ForgotPasswordPage from 'components/pages/ForgotPasswordPage/ForgotPasswordPage';
import RegistrationPage from 'components/pages/RegistrationPage/RegistrationPage';
import ResolveInvitePage from 'components/pages/ResolveInvitePage/ResolveInvitePage';
import JumioRedirectPage from 'components/pages/JumioRedirectPage/JumioRedirectPage';
import ContractSigningRedirectPage from 'components/pages/ContractSigningRedirectPage/ContractSigningRedirectPage';

import { PATH } from 'constants/common';
import PricingPage from 'components/pages/PricingPage/PricingPage';
import PaymentRequestPublicPage from 'components/pages/PaymentRequestPublicPage/PaymentRequestPublicPage';
import PaymentTrackingPublicPage from 'components/pages/PaymentTrackingPublicPage/PaymentTrackingPublicPage';
import ExpensesPublicPage from 'components/pages/ExpensesPublicPage/ExpensesPublicPage';
import DeviceWhitelistingPublicPage from 'components/pages/DeviceWhitelistingPublicPage/DeviceWhitelistingPublicPage';

export const history = History();

const Login = () => (
    <Switch>
        <Route path={PATH.LOGIN} component={LoginPage} exact />
        <Route
            path={PATH.LOGIN_WIR}
            render={() => <LoginPage variant={LayoutVariants.WIR} />}
        />
        <Route
            path={PATH.LOGIN_A352}
            render={() => <LoginPage variant={LayoutVariants.A352} />}
        />
        <Route
            path={PATH.LOGIN_WIENER_PRIVATBANK}
            render={() => (
                <LoginPage variant={LayoutVariants.WIENER_PRIVATBANK} />
            )}
        />
    </Switch>
);

const UnauthenticatedApp = () => (
    <Layout>
        <Switch>
            <Route
                path={PATH.CONTACT_INVITE}
                component={() => <ResolveInvitePage type="contact" />}
            />
            <Route
                path={PATH.BP_INVITE}
                component={() => <ResolveInvitePage type="business-partner" />}
            />

            <Route path={PATH.BEXIO} component={BexioAuthPage} />

            <Route
                path={PATH.LOGIN}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <Login />
                    </GoogleReCaptchaProvider>
                )}
            />
            <Route
                path={PATH.REGISTRATION_CARD}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage variant={LayoutVariants.CARD} />
                    </GoogleReCaptchaProvider>
                )}
            />
            <Route
                path={PATH.REGISTRATION}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage variant={LayoutVariants.DEFAULT} />
                    </GoogleReCaptchaProvider>
                )}
            />
            <Route
                path={PATH.REGISTRATION_WIR}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage variant={LayoutVariants.WIR} />
                    </GoogleReCaptchaProvider>
                )}
            />
            <Route
                path={PATH.REGISTRATION_A352}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage variant={LayoutVariants.A352} />
                    </GoogleReCaptchaProvider>
                )}
            />
            <Route
                path={PATH.REGISTRATION_WIENER_PRIVATBANK}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage
                            variant={LayoutVariants.WIENER_PRIVATBANK}
                        />
                    </GoogleReCaptchaProvider>
                )}
            />

            <Route
                path={PATH.REGISTRATION_RATE_ALERT}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage variant={LayoutVariants.DEFAULT} />
                    </GoogleReCaptchaProvider>
                )}
            />

            <Route
                path={PATH.REGISTRATION_BEXIO_INIT}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage variant={LayoutVariants.BEXIO} />
                    </GoogleReCaptchaProvider>
                )}
            />
            <Route
                path={PATH.REGISTRATION_BEXIO}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage variant={LayoutVariants.BEXIO} />
                    </GoogleReCaptchaProvider>
                )}
            />
            <Route
                path={PATH.REGISTRATION_TWENTYFOUR_SEVEN}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <RegistrationPage
                            variant={LayoutVariants.TWENTYFOUR_SEVEN}
                        />
                    </GoogleReCaptchaProvider>
                )}
            />

            <Route
                path={PATH.FORGOT_PASSWORD}
                render={() => (
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
                        <ForgotPasswordPage />
                    </GoogleReCaptchaProvider>
                )}
            />

            <Route
                path={`${PATH.RESET_PASSWORD}/:hash`}
                component={ResetPasswordPage}
                exact
            />

            <Route path="/jumio/:status" component={JumioRedirectPage} />

            <Route
                path={PATH.SKRIBBLE_SUCCESS}
                component={ContractSigningRedirectPage}
            />
            <Route path={PATH.PRICING} component={PricingPage} />

            <Route
                path={`${PATH.PAYMENT_REQUEST_PUBLIC}/:hash`}
                component={PaymentRequestPublicPage}
            />

            <Route
                path={`${PATH.PAYMENT_TRACKING}/:hash`}
                component={PaymentTrackingPublicPage}
            />
            <Route
                path={`${PATH.EXPENSES_PUBLIC}/:hash`}
                component={ExpensesPublicPage}
            />
            <Route
                path={`${PATH.DEVICE_WHITELISTING_PUBLIC}/:uuid/:hash`}
                component={DeviceWhitelistingPublicPage}
            />
            <Redirect
                to={{
                    pathname: PATH.LOGIN,
                    search: `afterLoginRedirect=${window.btoa(history.location.pathname + history.location.search)}`,
                }}
            />
        </Switch>
    </Layout>
);

export default UnauthenticatedApp;
